// extracted by mini-css-extract-plugin
export var attachment = "_ka-a";
export var emailContainer = "_ka-4";
export var emailContentPaddedContainer = "_ka-b";
export var emailHeader = "_ka-6";
export var emailIframe = "_ka-3";
export var emailInfoIcon = "_ka-9";
export var emailShortenedSummary = "_ka-e";
export var infoDropdown = "_ka-0";
export var infoRowBoundedContent = "_ka-d";
export var internal = "_ka-5";
export var merchant = "_ka-8";
export var messageInputContainer = "_ka-h";
export var normal = "_ka-7";
export var replyCard = "_ka-f";
export var subtleButton = "_ka-1";
export var subtleButtonIconContainer = "_ka-2";
export var toggleViewRepliesButton = "_ka-c";
export var wrappingText = "_ka-g";